const readString = (value) => (typeof value === 'string' && value.trim() ? value.trim() : '');

const walkBlocks = (blocks, visit) => {
  if (!Array.isArray(blocks)) return;
  blocks.forEach((block) => {
    if (!block || typeof block !== 'object') return;
    visit(block);
    walkBlocks(block.blocks, visit);
  });
};

export const extractCredentialSetupFromToolResult = (toolName, result) => {
  if (String(toolName || '').trim() !== 'request_integration_credential_setup') return null;
  if (!result || typeof result !== 'object' || result.success === false) return null;
  const action = result.user_action_required;
  if (!action || action.type !== 'integration_credentials') return null;
  const requestId = readString(action.request_id);
  const connectionId = readString(action.connection_id);
  if (!requestId || !connectionId) return null;
  return {
    requestId,
    connectionId,
    connectionName: readString(action.connection_name) || null,
    expiresAt: readString(action.expires_at) || null,
  };
};

export const latestCredentialSetupFromMessages = (messages) => {
  let found = null;
  (Array.isArray(messages) ? messages : []).forEach((message) => {
    walkBlocks(message?.blocks, (block) => {
      const action = extractCredentialSetupFromToolResult(
        block.toolName,
        block.result
      );
      if (action) found = action;
    });
  });
  return found;
};

